import { createContext } from "react";
import jwt_decode from "jwt-decode";
// import { NotificationManager } from "react-notifications";
import axios from "axios";
import axiosAuth from "../Axios/Interceptors";
import * as Utility from "../Shared/Utility";
import { useGlobalState } from "./GlobalStateContext";
const AppContext = createContext(null) as any;

AppContext.UserGeneralData = [];

AppContext.Token = "atk";
AppContext.RefreshToken = "atkr";
AppContext.ReturnURL = "ru";
AppContext.SNTKN = "sntkn";
AppContext.App = 9;
AppContext.PermittedApps = "";
AppContext.PermittedAppList = [];
AppContext.ManageAdmin = false;
AppContext.DirectorAccess = false;
AppContext.OverseasAccess = false;
AppContext.Domain = "domain=.pfibusinesstools.com";

AppContext.ManageObj = {};
AppContext.AppAccessLevelData = {};

//Live
// AppContext.AuthWebLink  = "https://auth.jlrmenabusinesstools.com/login"
// AppContext.AppBaseURL = "https://apiibbdata.jlrmenabusinesstools.com/";
// AppContext.AppAuthBaseURL = "https://apiauthdata.jlrmenabusinesstools.com/";
// AppContext.CommAPI = "https://apicommdata.jlrmenabusinesstools.com/";
// AppContext.FileManegmentAPI = "https://apimanagefilesdata.jlrmenabusinesstools.com/";
// AppContext.GetCommFiles ="https://files.jlrmenabusinesstools.com/filesjlrappcht/";
// AppContext.EmailAPIBaseURL = "https://apiemailsdata.jlrmenabusinesstools.com/";

//Demo
AppContext.AuthWebLink = "https://auth.pfibusinesstools.com/login";
AppContext.AppBaseURL = "https://apiibbdata.pfibusinesstools.com/";
AppContext.AppAuthBaseURL = "https://apiauthdata.pfibusinesstools.com/";
AppContext.CommAPI = "https://apicommdata.pfibusinesstools.com/";
AppContext.FileManegmentAPI =
  "https://apimanagefilesdata.pfibusinesstools.com/";
AppContext.GetCommFiles = "https://files.pfibusinesstools.com/filesjlrappcht/";
AppContext.EmailAPIBaseURL = "https://apiemailsdata.pfibusinesstools.com/";

AppContext.AppIdentifier = "JuOwwqn";
AppContext.RefreshInProgressMessage =
  "Refresh data is in progress. screen will be updated with the latest data shortly.";
AppContext.RefreshDoneMessage = "Data has been refreshed.";

// // Local Host
// AppContext.AppBaseURL = "https://localhost:7274/";
// AppContext.Domain = "domain=localhost";

AppContext.selectedCurrencyType = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
AppContext.selectedTabBrand = [0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3];
AppContext.NumberOfYears = 3;
AppContext.NumberOfYearsArray = [0, 1, 2, 3, 4];
AppContext.NumberOfMonthsArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
AppContext.BusinessPlanGeneralData = {};
AppContext.BPID = 0;
AppContext.SectionID = 0;
AppContext.MasterBPID = 0;
AppContext.BreadCrumbArray = [];

AppContext.IsProduction = false;
AppContext.ScoreCardFiltersIDs = {
  Dealers: 15,
  Years: 0,
  Quarter: 0,
  ScreenID: 0,
};

AppContext.NetworkTotalScore = 0;
AppContext.SalesTotalScore = 0;
AppContext.AftersalesTotalScore = 0;

AppContext.FileUploadObjectTypeHeaderData = 1;
AppContext.FileUploadObjectTypeIBBScorecardExceptions = 101;
AppContext.FileUploadObjectTypeBulkInput = 102;
AppContext.FileUploadObjectTypeCommFile = 103;
AppContext.FileUploadObjectTypeCOPAUpload = 104;
AppContext.FileUploadObjectTypeApprovalFile = 105;
AppContext.FileUploadObjectTypeProgramPolicy = 106;
AppContext.FileUploadObjectTypeExceptionApprovalFile = 107;
AppContext.FileUploadObjectTypeTargetApprovalFile = 108;
AppContext.FileUploadObjectTypeActualApprovalFile = 109;
AppContext.FileUploadObjectTypeInvoiceFile = 110;
AppContext.FileUploadObjectTypeCreditNoteApprovalFile = 111;
AppContext.FileUploadObjectTypeReInvestmentFile = 112;
AppContext.FileUploadObjectTypeConditionalHoldEvidenceFile = 113;
AppContext.FileUploadObjectTypeConditionalHoldApprovalFile = 114;
AppContext.FileUploadObjectTypeScorecardActualsEvidenceFile = 115;

AppContext.UserApplicationAccessSettings = [];

AppContext.IBBScreens = [
  { Name: "/", AccessType: 2, ObjectID: 1, CheckDID: true },
  { Name: "/programdashboard", AccessType: 2, ObjectID: 1, CheckDID: true },
  { Name: "/programoverview", AccessType: 2, ObjectID: 29, CheckDID: true },
  { Name: "/programapproval", AccessType: 2, ObjectID: 2, CheckDID: true },
  { Name: "/scorecard", AccessType: 2, ObjectID: 3, CheckDID: false },
  { Name: "/bulkinput?tid=1", AccessType: 2, ObjectID: 4, CheckDID: true },
  { Name: "/exceptions", AccessType: 2, ObjectID: 5, CheckDID: true },
  {
    Name: "/conditionalholdapproval",
    AccessType: 2,
    ObjectID: 6,
    CheckDID: true,
  },
  { Name: "/reinvestment", AccessType: 2, ObjectID: 7, CheckDID: true },
  { Name: "/ibbformulaselection", AccessType: 2, ObjectID: 8, CheckDID: true },
  { Name: "/copa", AccessType: 2, ObjectID: 9, CheckDID: true },
  { Name: "/copainvoicesdata", AccessType: 2, ObjectID: 10, CheckDID: false },
  { Name: "/invoicesdata", AccessType: 2, ObjectID: 11, CheckDID: false },
  { Name: "/creditnotesdata", AccessType: 2, ObjectID: 12, CheckDID: true },
  { Name: "/creditnotesapproval", AccessType: 2, ObjectID: 13, CheckDID: true },
  { Name: "/paymentcriteria", AccessType: 2, ObjectID: 14, CheckDID: true },
  { Name: "/exceptionhistory", AccessType: 2, ObjectID: 15, CheckDID: false },
  {
    Name: "/conditionalholdhistory",
    AccessType: 2,
    ObjectID: 16,
    CheckDID: false,
  },
  {
    Name: "/reinvestmentapproval",
    AccessType: 2,
    ObjectID: 17,
    CheckDID: true,
  },
  { Name: "/programlist", AccessType: 2, ObjectID: 18, CheckDID: false },
  { Name: "/approvalsettings", AccessType: 2, ObjectID: 19, CheckDID: false },
  { Name: "/grouplist", AccessType: 2, ObjectID: 20, CheckDID: false },
  { Name: "/functionalarea", AccessType: 2, ObjectID: 21, CheckDID: false },
  { Name: "/importersettings", AccessType: 2, ObjectID: 22, CheckDID: false },
  { Name: "/useraccesslevel", AccessType: 2, ObjectID: 23, CheckDID: false },
  { Name: "/emailtemplates", AccessType: 2, ObjectID: 24, CheckDID: false },
  { Name: "/deadlinemanagement", AccessType: 2, ObjectID: 25, CheckDID: false },
  { Name: "/triggers", AccessType: 2, ObjectID: 25, CheckDID: false },
];

AppContext.YearList = [
  {
    PID: 2018,
    Name: "2018/19",
  },
  {
    PID: 2019,
    Name: "2019/20",
  },
  {
    PID: 2020,
    Name: "2020/21",
  },
  {
    PID: 2021,
    Name: "2021/22",
  },
  {
    PID: 2022,
    Name: "2022/23",
  },
  {
    PID: 2023,
    Name: "2023/24",
  },
  {
    PID: 2024,
    Name: "2024/25",
  },
  {
    PID: 2025,
    Name: "2025/26",
  },
  {
    PID: 2026,
    Name: "2026/27",
  },
  {
    PID: 2027,
    Name: "2027/28",
  },
  {
    PID: 2028,
    Name: "2028/29",
  },
];

AppContext.QuarterList = [
  {
    PID: 1,
    Name: "Q1",
  },
  {
    PID: 2,
    Name: "Q2",
  },
  {
    PID: 3,
    Name: "Q3",
  },
  {
    PID: 4,
    Name: "Q4",
  },
];

AppContext.BrandList = [
  {
    PID: 2,
    Name: "All Brands",
  },
  {
    PID: 3,
    Name: "PFI Brand 3",
  },
  {
    PID: 4,
    Name: "PFI Brand 4",
  },
];

AppContext.ConvertDateTimeToLocal = (date: any) => {
  date = new Date(date);
  var localOffset = date.getTimezoneOffset() * 60000;
  var localTime = date.getTime();
  date = localTime - localOffset;
  date = new Date(date);

  // let text = date.toLocaleString();
  // date = new Date(text);

  return date;
};

AppContext.ShowNotification = (Type: any, Message: any) => {
  alert(Message);
  // switch (Type) {
  //   case "info":
  //     NotificationManager.info(Message);
  //     break;
  //   case "success":
  //     NotificationManager.success(Message, "Success");
  //     break;
  //   case "warning":
  //     NotificationManager.warning(Message, "Close after 3000ms", 3000);
  //     break;
  //   case "error":
  //     NotificationManager.error(Message, "Error!", 5000, () => {
  //       //alert('callback');
  //     });
  //     break;
  // }
};

AppContext.IsJwtExpired = (token: any) => {
  if (token && token !== "") {
    var UserInfo: any = jwt_decode(token);
    let currentDate = new Date();
    if (UserInfo.exp * 1000 < currentDate.getTime()) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
};

AppContext.CheckLoginValidity = async () => {
  let object = {} as any;
  let ReturnData = { role: "" };
  await axiosAuth
    .post(AppContext.AppAuthBaseURL + "api/SiteUser/CheckLoginValidity", object)
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data.Data[0][0];
        ReturnData = l_response;
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
      return ReturnData;
    });

  return ReturnData;
};

AppContext.CheckAccessAndSettings = async (completeURL: string, jlr: any) => {
  let object = {} as any;
  object.appid = AppContext.App;
  object.other = completeURL;
  let permissionStatus = false;
  await axiosAuth
    .post(
      AppContext.AppAuthBaseURL + "api/SiteUser/CheckAccessAndSettingsIBB",
      object
    )
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data.Data[0][0];
        AppContext.AppAccessLevelData = l_response;
        AppContext.PermittedApps = l_response.AppList;
        AppContext.PermittedAppList = response.data.Data[1];
        if (l_response.ManageAdmin == 1) {
          AppContext.ManageAdmin = true;
        } else {
          AppContext.ManageAdmin = false;
        }

        if (l_response.DirectorAccess == 1) {
          AppContext.DirectorAccess = true;
        } else {
          AppContext.DirectorAccess = false;
        }

        if (l_response.OverseasAccess == 1) {
          AppContext.OverseasAccess = true;
        } else {
          AppContext.OverseasAccess = false;
        }
        let Status = l_response.Status;
        if (Status === 1) {
          if (jlr === 0) {
            permissionStatus = true;
          } else {
            permissionStatus = response.data.Data[2][0].ManageAdmin;
          }
        }
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
      return permissionStatus;
    });

  return permissionStatus;
};

AppContext.CheckAccessAsAdmin = async () => {
  let object = {} as any;
  object.appid = AppContext.App;
  let isAdminLoggedIn = false;
  await axiosAuth
    .post(AppContext.AppAuthBaseURL + "api/SiteUser/CheckAccessAsAdmin", object)
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data;
        let Status = l_response.Status;
        if (Status === 1) {
          isAdminLoggedIn = true;
        }
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
      return isAdminLoggedIn;
    });

  return isAdminLoggedIn;
};

AppContext.GetUserApplicationAccessSettings = async () => {
  let object = {} as any;
  await axiosAuth
    .post(
      AppContext.AppBaseURL + "api/IBBProgram/GetUserApplicationAccessSettings",
      object
    )
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data.Data[0];
        AppContext.UserApplicationAccessSettings = l_response;
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });

  return AppContext.UserApplicationAccessSettings;
};

AppContext.GetBusinessPlanGeneralData = () => {
  let object = {} as any;
  object.bpid = AppContext.BPID;
  axiosAuth
    .post(
      AppContext.AppBaseURL + "api/PFIBusinessPlan/GetBusinessPlanGeneralData",
      object
    )
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data.Data[0][0];
        AppContext.BusinessPlanGeneralData = l_response;
        Utility.SetBPGeneralData();
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

AppContext.GetUserGeneralData = () => {
  let object = {} as any;
  axiosAuth
    .post(AppContext.AppBaseURL + "api/SiteUser/GetUserGeneralData", object)
    .then((response) => {
      if (response.data.Status === 1) {
        var l_response = response.data.Data;
        AppContext.UserGeneralData = l_response;
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

AppContext.PTCheckPasswordValidation = (FieldValue: any) => {
  //var RegExpresson = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  var RegExpresson = /^(?=.*["}{)(|,'?><_~!@#\$%\^&\*^%:;.`/-])/;
  //var l_boolValid = RegExpresson.test(FieldValue);
  var l_boolValid = true;
  var HasWhiteSpace = false;
  var Message = "";
  if (/\s/.test(FieldValue)) {
    // It has any kind of whitespace
    HasWhiteSpace = true;
  }
  if (HasWhiteSpace) {
    l_boolValid = false;
    IsAnyError = true;

    Message =
      "<br /><span class='p-error'>White spaces are not allowed.</span>";
  }
  var IsAnyError = false;
  if (FieldValue.length < 8) {
    Message +=
      "<br /><span class='p-error'>A minimum of 8 characters required.</span>";
    IsAnyError = true;
    l_boolValid = false;
  } else {
    Message +=
      "<br /><span class='p-ok'>A minimum of 8 characters required.</span>";
  }

  if (!/[a-z]/.test(FieldValue)) {
    Message +=
      "<br /><span class='p-error'>At least one lowercase letter is required.</span>";
    IsAnyError = true;
    l_boolValid = false;
  } else {
    Message +=
      "<br /><span class='p-ok'>At least one lowercase letter is required.</span>";
  }

  if (FieldValue == FieldValue.toLowerCase()) {
    Message +=
      "<br /><span class='p-error'>At least one capital letter is required.</span>";
    IsAnyError = true;
    l_boolValid = false;
  } else {
    Message +=
      "<br /><span class='p-ok'>At least one capital letter is required.</span>";
  }

  if (!/\d/.test(FieldValue)) {
    Message +=
      "<br /><span class='p-error'>At least one number is required.</span>";
    IsAnyError = true;
    l_boolValid = false;
  } else {
    Message +=
      "<br /><span class='p-ok'>At least one number is required.</span>";
  }
  // if (/^[a-zA-Z0-9- ]*$/.test(FieldValue) == true) {
  if (!RegExpresson.test(FieldValue)) {
    Message +=
      "<br /><span class='p-error'>At least one special character (e.g. @) is required.</span>";
    IsAnyError = true;
    l_boolValid = false;
  } else {
    Message +=
      "<span class='p-ok'>At least one special character (e.g. @) is required.</span>";
  }
  // }

  return { Valid: l_boolValid, Message: Message };
};

AppContext.GenerateUniqueGUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

AppContext.GetFileIconToDisplay = (FilePath: any) => {
  var IconURL = FilePath;
  var parts = FilePath.split(".");
  var ext = parts[parts.length - 1];
  switch (ext.toLowerCase()) {
    case "pdf":
      IconURL = "/DragDropIcons/pdficon.jpg";
      break;
    case "docx":
      IconURL = "/DragDropIcons/Word.jpg";
      break;
    case "doc":
      IconURL = "/DragDropIcons/Word.jpg";
      break;
    case "xlsx":
      IconURL = "/DragDropIcons/xls_icon.png";
      break;
    case "xls":
      IconURL = "/DragDropIcons/xls_icon.png";
      break;
    case "pptx":
      IconURL = "/DragDropIcons/ppt.png";
      break;
    case "ppt":
      IconURL = "/DragDropIcons/ppt.png";
      break;
    case "wav":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "mid":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "midi":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "wma":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "mp3":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "ogg":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "rma":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "au":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "ea":
      IconURL = "/DragDropIcons/audio.png";
      break;
    case "avi":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "mp4":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "divx":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "wmv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "mkv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "flv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "avi":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "vob":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "ogv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "wmv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "m4v":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "mov":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "wmv":
      IconURL = "/DragDropIcons/video.png";
      break;
    case "zip":
      IconURL = "/DragDropIcons/zip.png";
      break;
    case "rar":
      IconURL = "/DragDropIcons/zip.png";
      break;
    default:
      IconURL = FilePath;
  }
  return IconURL;
};

AppContext.SortJsonData = (JsonData: any, ColumnName: any) => {
  let SortedData = JsonData.sort((a: any, b: any) => {
    if (a[ColumnName] < b[ColumnName]) {
      return -1;
    }
  });

  return SortedData;
};

AppContext.GetCurrencyIconBasedOnCurrencyID = (CurrencyID: any) => {
  var CurrencyIcon = "$";
  switch (CurrencyID) {
    case 2:
      CurrencyIcon = "€";
      break;
    case 3:
      CurrencyIcon = "£";
      break;
    default:
      CurrencyIcon = "$";
  }
  return CurrencyIcon;
};

export default AppContext;
